export { default as ThreeDStockMaterialsCompactListItemInfo } from './ThreeDStockMaterialsCompactListItemInfo';
